// const Code = require('./code')
import latex from "./latex";
import listitem from "./list";
import Code from "./code"
import {Renderer} from "marked";

export interface Config {
  lineNumbers: boolean,
  getHeadingId: (s: string) => string
}

export default class Parser extends Code {
  private getHeadingId = (s: string) => s;

  constructor(config: Config = {
    lineNumbers: false,
    getHeadingId: (s: string) => s
  }) {
    super(config);
    this.getHeadingId = config.getHeadingId;
  }


  parser(option: Config): Partial<Renderer> {
    const {lineNumbers, getHeadingId = this.getHeadingId} = option;

    return {
      listitem,
      paragraph: latex,
      code: (block: string, lang: string) => this.code(block, lang, lineNumbers),
      heading: (text: string, level: number) => {
        const regex = /[^<]*(<a href="([^"]+)">([^<]+)<\/a>)/;
        const marched = text.match(regex);
        const id = getHeadingId(text);

        if (!marched) {
          return `<h${level}>
  <a href="#${id}" id="${id}"></a>${text}
</h${level}>`;
        }

        return `<h${level}>
  <a href="${marched[2]}" id="${marched[2].split("#")[1]}"></a>${marched[3]}
</h${level}>`;
      }
    };
  }
}
